import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  awardList: [],
  awardOrderList: [],
  awardDetail: [],
  loading: false,
  error: undefined,
};

const awardSlice = createSlice({
  name: "award",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchAwardList(state, action) {
      state.awardList = action.payload;
      state.loading = false;
    },
    fetchAwardOrderList(state, action) {
      state.awardOrderList = action.payload;
      state.loading = false;
    },
    fetchAwardDetail(state, action) {
      state.awardDetail = action.payload;
      state.loading = false;
    },
  },
});

export const awardActions = awardSlice.actions;

export default awardSlice.reducer;
